/** requestAnimationFrame-driven pulse; stopped immediately when a fresh line replaces the broken one. */
export class GlowAnimator {
  constructor(onFrame, duration = 1000) {
    this.onFrame = onFrame;
    this.duration = Math.min(1200, Math.max(800, duration));
    this.frame = null;
    this.startedAt = null;
  }

  start() {
    if (this.frame) return;
    const tick = (timestamp) => {
      this.startedAt ??= timestamp;
      const phase = ((timestamp - this.startedAt) % this.duration) / this.duration;
      this.onFrame(0.55 + Math.sin(phase * Math.PI * 2) * 0.45);
      this.frame = requestAnimationFrame(tick);
    };
    this.frame = requestAnimationFrame(tick);
  }

  stop() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = null;
    this.startedAt = null;
  }
}
